// @flow

import { Art as ArtBaseModel, ProductSku as ProductSkuBaseModel } from '@riseart/models';

/**
 * ProductSku
 */
class ProductSku extends ProductSkuBaseModel {
  errorDispatcher: Function;

  constructor(errorDispatcher: Function) {
    super();
    this.errorDispatcher = errorDispatcher;
  }

  /**
   * hydrateFromGqlData
   *
   * @param {Record<string, any>} data
   * @returns {Art}
   */
  hydrateFromGqlData(data: Record<string, any>): ?this {
    try {
      return this.hydrate(data);
    } catch (error) {
      this.errorDispatcher({ detail: error.message });
    }
  }
}

/**
 * Art
 */
class Art extends ArtBaseModel {
  errorDispatcher: Function;

  constructor(errorDispatcher: Function) {
    super();
    this.errorDispatcher = errorDispatcher;
  }

  /**
   * hydrateFromGqlData
   *
   * @param {Record<string, any>} data
   * @returns {Art}
   */
  hydrateFromGqlData(data: Record<string, any>): ?this {
    try {
      return this.hydrate(data);
    } catch (error) {
      this.errorDispatcher({ detail: error.message });
    }
  }

  /**
   * hydrateProductSkuData
   *
   * @param {Record<string, any>} productData
   * @returns {Art}
   */
  hydrateProductSkuData(productData: Record<string, any>): ?this {
    try {
      const { items = [] } = productData || {};

      if (!items || !items.length) {
        return this;
      }

      // Find and hydrate primary sku
      const primarySku = items.find((sku) => sku.id === this.productPrimarySku.id);
      if (primarySku) {
        this.hydrate({
          productPrimarySku: new ProductSku().hydrateFromGqlData(primarySku),
        });
      }

      // Hydrate product skus
      return this.hydrate({
        productSkus: items.map((item) => new ProductSku().hydrateFromGqlData(item)),
      });
    } catch (error) {
      this.errorDispatcher({ detail: error.message });
    }
  }
}

export { Art };
